import React from 'react';
import './LabPhilosophy.css';

function LabPhilosophy() {
  return (
    <div className="page lab-philosophy">
      <div className="container-narrow">
        <header className="page-header">
          <h1>Lab Philosophy</h1>
          <p className="subtitle">
            Grounded in collaboration, rigour, and the integration of lived
            experience.
          </p>
          <div className="accent-bar"></div>
        </header>

        <div className="philosophy-content">
          <section className="philosophy-block">
            <p className="philosophy-lead">
              Our lab is rooted in a patient-centered, collaborative philosophy
              that values and integrates both lived experience and scientific
              rigour.
            </p>
            <p>
              We believe that meaningful research integrates diverse
              perspectives to address complex questions, to allow for optimal
              translation into improved health outcomes. Our lab prioritizes
              mentorship and capacity-building, and an environment in which
              individuals can grow as thoughtful, impactful leaders in
              research and healthcare.
            </p>
          </section>

          <section className="philosophy-block">
            <p>
              We foster a transdisciplinary research environment that
              encourages curiosity, collaboration, and innovation. Our lab
              employs translational research methods to examine the complex
              interplay between reproductive, cardiovascular, and kidney
              health and disease. Guided by a deep commitment to equity and
              inclusion, and a dedication to transparency and accountability,
              our work aims to address gaps in knowledge that not only advance
              science but will also translate into precise and impactful
              clinical care.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default LabPhilosophy;
